import codeEditorService from '@/services/embeds/plugin/code.editor.service'
import {
  useEmbedConfigureStore,
  type IComponentSettings
} from '@/stores/embeds/embedConfigure.store'
import { useIdeStore } from '@/stores/embeds/ide.store'
import { JDOODLEBLOCKSNAMES } from '@/utils/embeds/editorMeta'

/**
 * set code editor font size
 * @param fontSize - font size
 */

/**
 * On setting change
 */
const onSettingChange = () => {
  const settongs = useEmbedConfigureStore().getComponentSettings?.find(
    (componentSetting: IComponentSettings) =>
      componentSetting.componentName === JDOODLEBLOCKSNAMES.FONTSIZE
  )?.configStyle
  const hideTitle = settongs?.find((setting) => setting.id === 'hideTitle')?.value || 'true'
  useIdeStore().setFontSizeHideTitle(hideTitle === 'true' || false)
  const titleName =
    settongs?.find((setting) => setting.id === 'titleName')?.value || 'Editor Font Size:'
  useIdeStore().setFontSizeTitleName(titleName)
  const display = settongs?.find((setting) => setting.id === 'display')?.value || 'true'
  useIdeStore().setFontSizeDisplay(display === 'true' || false)
}
/**
 * Init language list
 */
const initFontSize = () => {
  const defaultFontSize = useEmbedConfigureStore().getEmbedConfig?.defaultConfig?.fontSize || 12
  useIdeStore().setFontSize(defaultFontSize)
  codeEditorService.codeEditorSetFontSize()
}
/**
 * Eject input argus
 */
const destroyFontSize = async () => {
  const defaultFontSize = useEmbedConfigureStore().getEmbedConfig?.defaultConfig?.fontSize || 12
  useIdeStore().setFontSize(defaultFontSize)
  await codeEditorService.codeEditorSetFontSize()

  await new Promise((resolve) => setTimeout(resolve, 100))
}
export default {
  initFontSize,
  onSettingChange,
  destroyFontSize
}
